export class Answer {
  constructor(
    public groupId: number,
    public sortIndex: number,
    public questionId: number,
    public question: string,
    public answer: string[],
    public images: string[],
    public matrixGroupId: number,
    public matrixX: number,
    public matrixY: number,
  ) {}
}
